export const ITEMS_COUNT = {
  ONE: Symbol('one'),
  TWO: Symbol('two'),
  MULTIPLE: Symbol('multiple')
}

export const COMPARISONS = {
  LESS: {
    name: 'less',
    itemsCount: ITEMS_COUNT.ONE
  },
  GREATER: {
    name: 'greater',
    itemsCount: ITEMS_COUNT.ONE
  },
  BETWEEN: {
    name: 'between',
    itemsCount: ITEMS_COUNT.TWO
  },
  IN: {
    name: 'in',
    itemsCount: ITEMS_COUNT.MULTIPLE
  },
  EQUAL: {
    name: 'equal',
    itemsCount: ITEMS_COUNT.ONE
  },
  LIKE: {
    name: 'like',
    itemsCount: ITEMS_COUNT.ONE
  }
}

export const OPERANDS = {
  AND: 'AND',
  OR: 'OR'
}
